import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
  error: null,
  loading: false,
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    userProfileRequestStarted: (state) => {
      state.data = null;
      state.error = null;
      state.loading = true;
    },
    userProfileRequestSuccess: (state, action) => {
      // Normalize different response structures:
      // 1. Login: { token, user: { userId, userName, ... } }
      // 2. Profile fetch: { userId, userName, ... } (flat)
      const payload = action.payload;

      if (payload.user) {
        // Login response - has nested user object
        state.data = payload; // Keep as-is with nested structure
      } else if (payload.userId) {
        // Profile fetch response - flat structure, wrap it
        state.data = {
          user: payload,
          ...payload, // Keep flat fields for backward compatibility
        };
      } else {
        // Unknown structure, store as-is
        state.data = payload;
      }

      state.error = null;
      state.loading = false;
    },
    userProfileRequestError: (state, action) => {
      state.data = null;
      state.error = action.payload;
      state.loading = false;
    },
    resetUserProfile: (state) => {
      // CRITICAL: Complete reset to initial state to prevent cross-user data
      state.data = null;
      state.error = null;
      state.loading = false;
    },
    userProfileUpdated: (state, action) => {
      // Merge updates into data.user to keep structure consistent
      if (state.data && state.data.user) {
        state.data.user = { ...state.data.user, ...action.payload };
        // Also update top-level fields if they exist (for backward compatibility)
        state.data = { ...state.data, ...action.payload };
      } else {
        state.data = { ...state.data, ...action.payload };
      }
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  userProfileRequestStarted,
  userProfileRequestSuccess,
  userProfileRequestError,
  resetUserProfile,
  userProfileUpdated,
} = userProfileSlice.actions;
export default userProfileSlice.reducer;
